// extracted by mini-css-extract-plugin
export default {"wrapper":"PlusMinusToggle_wrapper__rAz9A","plusMinusToggle":"PlusMinusToggle_plusMinusToggle__q1WDL"};